import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import { GlobalTemplateService } from '../../../../../services/global-template.service';
import { VariableMaxLengthService } from '../../../../../services/variable-max-length.service';

import {
  RsaSearchCallsInitModel,
  RsaSearchCallsInitVariables,
  RsaSearchCallsModel,
  RsaSearchCallsVariables,
} from '../../../../../models/google-template/rsa-search-calls.interface';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { BaseComponent } from '../../../common/BaseComponent';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';
import { SelectModule } from '@openng/optimus-ui/select';
import { ToastBarService } from '../../../../../services/toast-bar.service';

export interface Country {
  id: number,
  name: string
}
@Component({
    selector: 'app-rsa-search-calls',
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
        SelectModule
    ],
    templateUrl: './rsa-search-calls.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './rsa-search-calls.component.scss'
})
export class GoogleRsaSearchCallsComponent extends BaseComponent implements OnInit, OnDestroy {
  //@ input
  @Input() block: RsaSearchCallsModel = new RsaSearchCallsInitModel();
  @Input() isPreview = false;
  //@ output
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  countries: Country[] = [{ id: 1, name: 'Croatia' }, { id: 2, name: 'Austria' }];
  selectedCountry: string = '';
  disabled: boolean = true;
  private _destroy$ = new Subject<void>();

  constructor(
    toastBarService: ToastBarService,
    private globalTemplateService: GlobalTemplateService,
    private _variableMaxLengthService: VariableMaxLengthService
  ) {
    super(toastBarService);
  }

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new RsaSearchCallsInitVariables()
    }

    // Preselect the saved country (stored as its name) when the editor opens.
    this.selectedCountry = this.block.variables!['Country'] ?? '';

    // Disable the dropdown when the template is read-only or locked by another user.
    this.globalTemplateService
      .getIsDisabled()
      .pipe(takeUntil(this._destroy$))
      .subscribe((isDisabled: boolean) => {
        this.disabled = isDisabled;
      });

    // Register the Country max length so the docx export prints a value (not "Undefined").
    this._variableMaxLengthService.addSingleVariableMaximumLength({
      name: 'Country',
      maxLength: 4000,
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  //@ placeholders
  countryPlaceholder: string = 'Select country';
  telephoneNumberPlaceholder: string = 'Enter telephone number';

  //@remove
  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  //@onChange
  onChange(value: any, fieldName: keyof RsaSearchCallsVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof RsaSearchCallsVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
